module.exports = __webpack_public_path__ + "static/media/chair3right.238941c1.png";